// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/utils/metas.ts"
);
import.meta.hot.lastModified = "1725977714068.7402";
}
// REMIX HMR END

import SYS_CONFIG from "~/config";
import { cutLangSegmentFromPath } from "./lang"
import { MetaDescriptor } from "@remix-run/node";

export const createHrefLangObjForMetas = (url: string): MetaDescriptor[] => {
    const urlWithoutLangParam = cutLangSegmentFromPath(url);
    let outp: MetaDescriptor[] = []
    for (let i = 0; i < SYS_CONFIG.SUPPORTED_LANG_OBJECTS.length; i += 1) {
        const obj = SYS_CONFIG.SUPPORTED_LANG_OBJECTS[i]
        outp = [...outp, {
            tagName: "link",
            rel: "alternate",
            hrefLang: obj.lang_html,
            href: SYS_CONFIG.URL_SITE_DOMAIN + (obj.lang_param === '' ? urlWithoutLangParam : `/${obj.lang_param + urlWithoutLangParam}`)
        }]
    }

    return outp
}


